export const UPDATE_PEPPOL_METHOD = 'update_peppol_method';
export const UPDATE_ACCOUNTING_EMAIL = 'update_accounting_email';
export const UPDATE_COMPANY_NUMBER = 'update_company_number';
export const UPDATE_GLN = 'update_gln';
export const UPDATE_GOVERNING_INSTITUTION_PEPPOL_IDENTIFIER = 'update_governing_institution_peppol_identifier';
export const ACCOUNTING_DATA_FETCHED = 'accounting_data_fetched';
export const FETCH_ACCOUNTING_DATA_FAILED = 'fetch_accounting_data_failed';
export const PERSIST_GLN_FAILED = 'persist_gln_failed';
export const PERSIST_COMPANY_NUMBER_FAILED = 'persist_company_number_failed';

export const accountingDataFetched = (data) => ({
  type: ACCOUNTING_DATA_FETCHED,
  payload: data,
});
export const fetchAccountingDataFailed = (error) => ({
  type: FETCH_ACCOUNTING_DATA_FAILED,
  payload: error,
});

export const updatePeppolMethod = (method) => ({
  type: UPDATE_PEPPOL_METHOD,
  payload: method,
});

export const updateAccountingEmail = (email, project) => ({
  type: UPDATE_ACCOUNTING_EMAIL,
  payload: { email, project },
});

export const updateCompanyNumber = (companyNumber) => ({
  type: UPDATE_COMPANY_NUMBER,
  payload: companyNumber,
});

export const updateGln = (relationHref, gln) => ({
  type: UPDATE_GLN,
  payload: { relationHref, gln },
});

export const updateGoverningInstitutionPeppolIdentifier = (ouHref, identifier) => ({
  type: UPDATE_GOVERNING_INSTITUTION_PEPPOL_IDENTIFIER,
  payload: { ouHref, identifier },
});

export const persistGlnFailed = (error, href, glnHref) => ({
  type: PERSIST_GLN_FAILED,
  payload: { error, href , glnHref },
});

export const persistCompanyNumberFailed = (error) => ({
  type: PERSIST_COMPANY_NUMBER_FAILED,
  payload: { error },
});